import React from 'react';
import useModal from '../context/ModalContext';

const PodcastCtaErrorContent = ({ error }) => {
  const { setContent } = useModal();

  return (
    <div className="flex flex-col items-center text-center" style={{ maxWidth: '440px' }}>
      <p className="pt-2 pb-8">
        {error?.message ||
          'Unable to send podcast link email. Please try again or contact support.'}
      </p>
      <button
        type="button"
        className="font-bold text-sm text-white bg-link-purple py-3 px-4 rounded-2lg"
        onClick={() => setContent()}
      >
        OK
      </button>
    </div>
  );
};

export default PodcastCtaErrorContent;
